module.exports = __webpack_public_path__ + "img/stromae_mars_2022.8cc95aa8.jpg";